import { ContactTracingContactDtoResidencyType } from '../api/generated/model';

export function getResidencyTypeName(residencyType: ContactTracingContactDtoResidencyType) {
  switch (residencyType) {
    case ContactTracingContactDtoResidencyType.PRIVATE:
      return 'Privatadresse';
    case ContactTracingContactDtoResidencyType.WITH_INDEX_PATIENT:
      return 'Unterbringung Indexpatient';
    case ContactTracingContactDtoResidencyType.OTHER:
      return 'Unterbringung anderswo';
  }
}
